import RegistrationCompte from '@/view/RegistrationCompte'

export default [
  {
    path: '/user/registrationCompte',
    name: 'registrationCompte',
    component: RegistrationCompte,
    meta: {
      auth: 'permit',
    },
  },
]
